export var PO_BOX_ADDRESS = {
    message: 'We can’t ship to a P.O. Box. Please enter a physical shipping address.',
};
export var FIRST_NAME_REQUIRED = {
    message: 'Please provide a first name.',
};
export var LAST_NAME_REQUIRED = {
    message: 'Please provide a last name.',
};
export var PHONE_REQUIRED = {
    message: 'Please provide a 10-digit phone number.',
};
export var COMPANY_NAME_INVALID = {
    message: 'Please use only letters (a-z), numbers, and the following symbols: &*#();@/.',
};
export var SHIPPING_ADDRESS_INVALID = {
    message: 'Please provide a valid shipping address.',
};
export var ZIP_CODE_REQUIRED = {
    message: 'Please provide a 5-digit ZIP code.',
};
export var ZIP_CODE_INVALID = {
    message: 'Please provide a valid ZIP code.',
};
export var CARD_HOLDER_NAME_REQUIRED = {
    message: 'Please provide the name on card.',
};
export var CARD_BILLING_ADDRESS_REQUIRED = {
    message: 'Please provide the billing address.',
};
export var CARD_EXP_MONTH_REQUIRED = {
    message: 'Please provide the card expiration month.',
};
export var CARD_EXP_YEAR_REQUIRED = {
    message: 'Please provide the card expiration year.',
};
export var CARD_HOLDER_NAME_INVALID = {
    message: 'Please provide a valid name on card.',
};
export var BILLING_ADDRESS_INVALID = {
    message: 'Please provide a valid billing address.',
};
export var CARD_NICKNAME_INVALID = {
    message: 'Please provide a valid card nickname.',
};
export var GIFT_CARD_ENOUGH_DIGITS = {
    message: 'Please provide the entire 23-digit gift card number.',
};
export var GIFT_CARD_REQUIRED = {
    message: 'Please enter a valid gift card number.',
};
export var CHECKING_ACCOUNT_NUMBER_INVALID = {
    message: 'Account numbers must have at least 4 digits.',
};
export var CHECKING_ACCOUNT_ROUTING_INVALID = {
    message: 'Routing numbers must have 9 digits.',
};
export var KEYTAG_NUMBER_INVALID = {
    message: "That doesn't seem to be a valid Keytag Number. Please try re-entering the number.",
};
export var NICKNAME_INVALID = {
    message: 'Please use only letters (a-z), numbers, and the following symbols &_#-.',
};
